import app from '~/app';
import relewiseCollection from '~/js/components/relewise-collection';
import collectionStoreDrawer from '~/js/components/collection-store-drawer';
import optionDrawer from '~/js/components/option-drawer';
import stlCollectionSlider from '~/js/components/stl-collection-slider';
import readMore from './collection/read-more';
import shopTheLook from './collection/shop-the-look';
import stlProductForm from './collection/stl-product-form';
import stlLinkedProducts from './collection/stl-linked-products';

app.add({
  'relewise-collection': relewiseCollection,
  'read-more': readMore,
  collectionStoreDrawer,
  'option-drawer': optionDrawer,
  'stl-collection': shopTheLook,
  'stl-product-form': stlProductForm,
  'stl-linked-products': stlLinkedProducts,
  'stl-collection-slider': stlCollectionSlider,
});

app.mount();
